module.exports = __webpack_public_path__ + "static/media/nonset_timer.43f61fd6.png";